import { gql } from '@apollo/client';

import { JOB_POSITION_FOR_LIST_FRAGMENT } from './job-position-for-list';

export const JOB_POSITION_FOR_GUEST_FRAGMENT = gql`
  fragment JobPositionForGuest on JobPositionForCandidateDto {
    distance
    id
    jobPosition {
      ...JobPositionForList
    }
    newPosition
  }
  ${JOB_POSITION_FOR_LIST_FRAGMENT}
`;
